import { Route } from "react-router-dom";
import { lazy } from "react";
import HatLegsTracking from "../../components/HigherAwardTracking/LegsTracking/HatLegsTracking/HatLegsTracking";
const HigherAwardTracking = lazy(() => import("../../components/HigherAwardTracking/HigherAwardTracking"));
const GlobalAwardLegQCDetails = lazy(
  () => import("../../components/HigherAwardTracking/GlobalAwardLegQCDetails/GlobalAwardLegQCDetails"),
);
const ABOsTracking = lazy(() => import("../../components/HigherAwardTracking/ABOsTracking/ABOsTracking"));

export enum HAT_ROUTES {
  BASE_PATH = "/hat/",
  LEG_TRACKING = "leg-tracking",
  LEG_QC_DETAILS = "leg-qc-details",
}

export enum GAR_ROUTES {
  BASE_PATH = "/gar/",
  LEG_QC_DETAILS = "leg-qc-details",
}

export const HAT_LEG_QC_DETAILS_ABO_ROUTE = `/hat/${HAT_ROUTES.LEG_QC_DETAILS}/:abo`;

export const HAT_SUB_ROUTES = [
  `/hat/${HAT_ROUTES.LEG_TRACKING}`,
  `/hat/${HAT_ROUTES.LEG_QC_DETAILS}`,
  HAT_LEG_QC_DETAILS_ABO_ROUTE,
];

export const GAR_SUB_ROUTES = [`/gar/${GAR_ROUTES.LEG_QC_DETAILS}`];

export const HatRoutes = () => {
  return (
    <Route path={HAT_ROUTES.BASE_PATH}>
      <Route index element={<HigherAwardTracking />} />
      <Route path={HAT_ROUTES.LEG_TRACKING} element={<HatLegsTracking />} />
      <Route path={HAT_ROUTES.LEG_QC_DETAILS} element={<GlobalAwardLegQCDetails />} />
      <Route path={`${HAT_ROUTES.LEG_QC_DETAILS}/:abo`} element={<ABOsTracking />} />
    </Route>
  );
};

export const GarRoutes = () => {
  return (
    <Route path={GAR_ROUTES.BASE_PATH}>
      <Route path={GAR_ROUTES.LEG_QC_DETAILS} element={<GlobalAwardLegQCDetails />} />
    </Route>
  );
};
